/* eslint-env browser */
import * as React from 'react'

import { computeTargetURLWithParameter } from '../../../../common/client/url-manipulator'
import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const classNames = require('classnames')
const axios = require('axios')

const { CancelToken } = axios

const GridFilter = require('./GridFilter')
const LargeGearItem = require('./LargeGearItem')

class GearsBySpecies extends React.Component {
  constructor(props) {
    super(props)

    const { productCategories, sortBy, productCategoriesIds, translate, bestSpeciesWithGear } = props

    this.state = {
      productCategoriesById: (productCategories || []).reduce((aggreg, elt) => {
        aggreg[elt.id] = elt
        return aggreg
      }, {}),
      filters: {
        productCategoriesIds,
      },
      sort: sortBy || 'usage',
      loading: false,
      bestSpeciesWithGear,
      sortOptions: [
        { key: 'usage', value: 'usage', display: translate('gears.gridSearch.sort.by.usage') },
        { key: 'date', value: 'date', display: translate('gears.gridSearch.sort.by.date') },
      ],
    }
    this.onChangeCategories = this.onChangeCategories.bind(this)
    this.onChangeSort = this.onChangeSort.bind(this)
    this.getMoreLink = this.getMoreLink.bind(this)

    this.searchCancelSource = CancelToken.source()
  }

  componentWillReceiveProps(nextProps) {
    const { productCategories } = nextProps
    this.setState({
      productCategoriesById: (productCategories || []).reduce((aggreg, elt) => {
        aggreg[elt.id] = elt
        return aggreg
      }, {}),
    })
  }

  onChangeCategories(newValue) {
    this.setState(
      prevState => ({
        filters: {
          ...prevState.filters,
          productCategoriesIds: [newValue],
        },
      }),
      this.updateResults
    )
  }

  onChangeSort(newValue) {
    this.setState(
      {
        sort: newValue,
      },
      this.updateResults
    )
  }

  getMoreLink({ speciesId }) {
    const { host, moreGearTargetPath } = this.props
    const { filters = {}, sort } = this.state

    const otherQueryParams = {
      'productCategoriesIds[]': filters.productCategoriesIds,
      sortBy: sort,
    }
    if (speciesId) {
      otherQueryParams['speciesIds[]'] = speciesId
    }

    return computeTargetURLWithParameter({
      host,
      path: moreGearTargetPath,
      queryParams: otherQueryParams,
    })
  }

  updateResults() {
    this.searchCancelSource.cancel()
    this.searchCancelSource = CancelToken.source()

    const { permanentFilters = {} } = this.props
    const { filters = {}, sort } = this.state

    let queryParams = {
      ...filters,
      ...permanentFilters,
    }

    this.setState({ loading: true })

    queryParams = Object.keys(queryParams)
      .map(key => ({ key, array: queryParams[key].filter(id => id !== '__ALL__') }))
      .filter(obj => obj.array.length > 0)
      .reduce((aggreg, obj) => {
        aggreg[obj.key] = obj.array
        return aggreg
      }, {})

    let url = '/api/renderProps/brands/XXX/fullSpecies'
    if (permanentFilters.brandsIds && permanentFilters.brandsIds.length > 0) {
      url = `/api/renderProps/brands/${permanentFilters.brandsIds[0]}/fullSpecies`
    }
    axios
      .get(url, {
        cancelToken: this.searchCancelSource.token,
        params: {
          ...queryParams,
          sortBy: sort,
        },
      })
      .then(res => {
        // TODO:
        this.setState(
          {
            bestSpeciesWithGear: res.data.bestSpeciesWithGear || [],
            loading: false,
          },
          () => {
            // this.changeUrlByState();
            // this.changeTitle();
          }
        )
      })
      .catch(err => {
        this.setState({ loading: false })
      })
  }

  render() {
    const { productCategoriesById, filters, sortOptions, sort, loading, bestSpeciesWithGear } = this.state

    const { translate, productCategories, host, hostPath, moreGearTargetPath } = this.props

    const productCategoriesFilter = (productCategories || []).map(elt => ({
      key: elt.id,
      value: elt.id,
      display: elt.name,
    }))

    const otherQueryParams = {
      'productCategoriesIds[]': filters.productCategoriesIds,
      sortBy: sort,
    }

    return (
      <div className="columns is-mobile is-multiline">
        <div className="column is-12 has-text-right">
          {productCategoriesFilter.length > 0 && (
            <GridFilter
              label={translate('gears.gridSearch.filters.categories.title')}
              allLabel={translate('gears.gridSearch.filters.categories.all')}
              options={productCategoriesFilter}
              onChange={this.onChangeCategories}
              value={filters.productCategoriesIds[0]}
              changeURLQueryParam="productCategoriesIds[]"
              host={host}
              hostPath={hostPath}
              otherQueryParams={otherQueryParams}
            />
          )}
          <GridFilter
            label={translate('gears.gridSearch.sort.title')}
            options={sortOptions}
            onChange={this.onChangeSort}
            value={sort}
            changeURLQueryParam="sortBy"
            host={host}
            hostPath={hostPath}
            otherQueryParams={otherQueryParams}
          />
        </div>
        <div className="column is-12">
          {loading && <div className="loader is-size-1 is-primary is-large is-self-centered" />}
          {!loading &&
            bestSpeciesWithGear.map((best, idx) => (
              <div key={best.species.id} className="column is-12 animated fadeIn faster">
                <div className="columns is-multiline has-ribbon-left">
                  <div className="column is-3">
                    {best.species.medias && best.species.medias.length > 0 && (
                      <a
                        href={`/fish/${best.species.seoName}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={best.species.name}
                      >
                        <figure className="image">
                          <img src={best.species.medias[0].url_600} alt={best.species.name} title={best.species.name} />
                        </figure>
                      </a>
                    )}
                    <h3 className="is-size-7 has-text-weight-bold has-text-primary-blue has-text-centered">
                      {best.species.name}
                    </h3>
                    <div className="tooltip is-tooltip-bottom" data-tooltip={`${best.species.percent}%`}>
                      <progress
                        className="progress is-success is-small has-margin-bottom-zero"
                        value={best.species.percent}
                        max="100"
                      >
                        {`${best.species.percent}%`}
                      </progress>
                    </div>
                  </div>
                  {idx < 3 && (
                    <div className={classNames('ribbon is-small is-primary small-shadow')}>
                      <strong className="has-text-white">{`${idx + 1}`}</strong>
                    </div>
                  )}
                  <div className="column is-9">
                    <div className="columns is-mobile is-multiline is-variable is-1">
                      {best.gear.map(gear => (
                        <div key={`${gear.type}-${gear.productArticleId}`} className="column is-4-mobile is-4-tablet">
                          <LargeGearItem gear={gear} productCategory={productCategoriesById[gear.productCategoryId]} />
                        </div>
                      ))}
                      {moreGearTargetPath && (
                        <a
                          href={this.getMoreLink({ speciesId: best.species.id })}
                          className="button is-rounded is-success small-shadow medium-shadow-on-hover"
                          style={{ position: 'absolute', right: 0, top: '50%' }}
                        >
                          <strong>+</strong>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                <hr className="has-margin-vertical-xxsmall" />
              </div>
            ))}
        </div>
      </div>
    )
  }
}

GearsBySpecies.propTypes = {
  translate: PropTypes.func.isRequired,
  permanentFilters: PropTypes.object,
  sortBy: PropTypes.string,
  productCategoriesIds: PropTypes.array,
  productCategories: PropTypes.array,
  bestSpeciesWithGear: PropTypes.array,
  host: PropTypes.string.isRequired,
  hostPath: PropTypes.string.isRequired,
  moreGearTargetPath: PropTypes.string,
}

GearsBySpecies.defaultProps = {
  sortBy: null,
  productCategoriesIds: [],
  productCategories: [],
  permanentFilters: {},
  bestSpeciesWithGear: [],
  moreGearTargetPath: null,
}

module.exports = withTranslator(GearsBySpecies)
